import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions as cartActions} from '../../../redux/modules/Cart'
import {bindActionCreators} from 'redux'
import PaymentPage from './PaymentPage'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import Loading from '../../../components/LoadingComponent'

const mapStateToProps = (state) => {
  return {
    cart: state.cart
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    cartActions: bindActionCreators(cartActions, dispatch)
  }
}

class PaymentPageContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      paymentData: null,
      cartItems: [],
      loading: false
    }

    this.onPayClick = this.onPayClick.bind(this)
    this.fetchCart = this.fetchCart.bind(this)
  }

  fetchCart () {
    SostaOnlineApiService.fetchCart().then((data) => {
      this.setState({loading: false, cartItems: data.data})
    })
  }

  componentWillMount () {
    this.setState({loading: true})
    this.fetchCart()
  }

  onPayClick () {
    SostaOnlineApiService.buyParkingTickets(this.state.cartItems).then(data => {
      this.setState({
        paymentData: data.data
      })
      window.location.href = 'https://ecomm.sella.it/pagam/pagam.aspx?a=' + this.state.paymentData.shopLogin + '&b=' + this.state.paymentData.cryptedString
    })
  }

  render () {
    if (this.state.loading) {
      return (<Loading />)
    }

    return (<PaymentPage onPayClick={this.onPayClick} items={this.state.cartItems} />)
  }
}

PaymentPageContainer.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPageContainer)



// WEBPACK FOOTER //
// ./src/containers/UserArea/Checkout/PaymentPageContainer.js